import React, { useState, useEffect } from "react";
import * as $ from "jquery";

export default function PreorderButton(props) {
    const fullParent = props.elem?.dataset?.full ? Boolean(props.elem.dataset.full) : props.full;
    let ID = props.elem?.dataset?.id ? Number(props.elem.dataset.id) : props.id;
    let propsSelected = props.elem?.dataset?.selected
        ? props.elem.dataset.selected
        : props.selected;
    let propsType =
        (props.elem?.dataset?.type && props.elem?.dataset?.type) || props.type || "book";
    const onlyIcon = props.elem?.dataset?.onlyicon ? Boolean(props.elem.dataset.onlyicon) : props.onlyIcon;

    const loggedIn = props.elem?.dataset?.loggedin
        ? props.elem.dataset.loggedin !== "false"
        : props.loggedIn;

    let [selected, setSelected] = useState(propsSelected);
    let [loading, setLoading] = useState(false);

    function wishlistIncludes(wishlist, id) {
        let filteredItems = [];
        if (propsType === "book")
            filteredItems = wishlist.items.filter((item) => item.id.toString() === id.toString());

        return filteredItems.length > 0;
    }

    useEffect(() => {
        // Fetching whislist
        window.Dibook.wishlist
            .fetchPreorderForItem(ID)
            .then((payload) => {
                setSelected(!!payload.content?.found);
            })
            .catch((error) => console.log(error));

        const addingSubId = window.Dibook.wishlist.on("itemsAdding", (payload) => {
            if (payload.preorder && payload.items.includes(ID)) setLoading(true);
        });

        const addedSubId = window.Dibook.wishlist.on("itemsAdded", (payload) => {
            setLoading(false);
            let items = payload.content?.data;
            if (payload.preorder && items) if (wishlistIncludes(items, ID)) setSelected(true);
            if (payload.status === 202) showLogin();
        });

        const removingSubId = window.Dibook.wishlist.on("itemsRemoving", (payload) => {
            if (payload.preorder && payload.items.includes(ID)) setLoading(true);
        });

        const removedSubId = window.Dibook.wishlist.on("itemsRemoved", (payload) => {
            setLoading(false);
            let items = payload.content?.data;
            if (payload.preorder && items) if (!wishlistIncludes(items, ID)) setSelected(false);
            if (payload.status === 202) showLogin();
        });

        return () => {
            window.Dibook.wishlist.off("itemsAdding", addingSubId);
            window.Dibook.wishlist.off("itemsAdded", addedSubId);
            window.Dibook.wishlist.off("itemsRemoving", removingSubId);
            window.Dibook.wishlist.off("itemsRemoved", removedSubId);
        };
    }, [ID]);

    if(onlyIcon)
        return (
            <Wrapper {...props}>
                <div
                    className={"new-cart-btn preorder "+(loading ? " loading-spin" : "")}
                    style={{ width: fullParent && "100%", cursor: "pointer" }}
                    data-selected={selected}
                    onClick={(event) => handleHeartClick(event, ID)}
                >
                    {selected && <img src="/images/icon/prerelease-icon-white.svg" />}
                    {!selected && <img src="/images/icon/prerelease-icon-black.svg" />}
                </div>
            </Wrapper>
        );

    return (
        <Wrapper {...props}>
            <div className="new-widget-cartbutton-component">
                <button
                    className={"new-cart-btn preorder " + (loading ? " loading-spin" : "")}
                    style={{ width: fullParent && "100%", cursor: "pointer" }}
                    data-selected={selected}
                    onClick={(event) => handleHeartClick(event, ID)}
                >
                    {selected && <p className="m-0">Előjegyezve</p>}
                    {!selected && <p className="m-0">Előjegyzem</p>}

                    {selected && <img src="/images/icon/prerelease-icon-white.svg" alt="Előjegyzés icon" />}
                    {!selected && <img src="/images/icon/prerelease-icon-black.svg" alt="Előjegyzés icon" />}
                </button>
            </div>
        </Wrapper>
    );

    function handleHeartClick(e, id) {
        e.stopPropagation();

        if (!loggedIn) {
            showLogin();
            return;
        }

        if (loading) return;
        setSelected(async (val) => {
            if (val) {
                await window.Dibook.wishlist.removeItems([id], propsType, true);
                return false;
            }
            await window.Dibook.wishlist.addItems([id], propsType, true);

            if(onlyIcon)
                showPreorderModal();

            return true;
        });
    }

    function showLogin() {
        window.$("#loginModal").modal("show");
    }

    function showPreorderModal() {
        $("#commonmodal .modal-body").css({ "min-height": "fit-content" });
        $("#commonmodal .h4").text("Sikeres előjegyzés");
        $("#commonmodal .modal-body-header").removeClass("mb-4");
        $("#commonmodal .modal-body-content").hide();
        $("#commonmodal .modal-footer").hide();
        $("#commonmodal button.okbutton").hide();
        $("#commonmodal").modal("show");
    }
}

function Wrapper(props) {
    if (props.elem?.className === "widget-heart") {
        return props.children;
    } else {
        return <div style={props.style || {}}>{props.children}</div>;
    }
}
